export default "__VITE_ASSET__CmAFvQTJ__"